import React from 'react'
import Dialog from '@mui/material/Dialog'
import { DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'

//common
import BottomButton from '../../common/BottomButton'
//types
import { IneligibleOrderModalProps } from 'types'

const TimeLimitModal = ({ showModal, hideModal }: IneligibleOrderModalProps) => {
  return (
    <Dialog open={showModal} onClose={hideModal} sx={styles.modal} maxWidth="xs">
      <div className="modalCloseButton">
        <img src="/images/modalCloseButton.png" onClick={hideModal} />
      </div>
      <DialogTitle variant="h1" sx={styles.title}>
        Gift Card Redemption Time Limit
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" className="confirmOrderModalText" sx={{ ...styles.text }}>
          There is a 3 minute cooldown before you can redeem another gift card. This is to make sure
          that you properly receive each gift card that you order. Please try again in a few
          minutes!
        </Typography>
      </DialogContent>
      <DialogActions>
        <BottomButton
          handleClick={hideModal}
          style={{ ...styles.closeButton, ...styles.centeredButton }}
        >
          Okay
        </BottomButton>
      </DialogActions>
    </Dialog>
  )
}

const styles = {
  modal: {
    '& .MuiDialog-paper': {
      borderRadius: '16px',
      margin: '21px',
    },
  },
  title: {
    textAlign: 'center',
  },
  text: {
    textAlign: 'center',
  },
  closeButton: {
    border: '2px solid rgb(251, 146, 60)',
    backgroundColor: '#ffffff',
    color: '#000000',
  },
  centeredButton: {
    width: '55%',
    margin: '0 auto',
    display: 'block',
  },
}

export default TimeLimitModal
